import { useEffect, useRef, useState } from "react";
import { SelectChoice, SetupKind } from "../../../helpers/types";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_USERS } from "../../../graphql/queries";
import { ComboboxItem, OptionsFilter, Select } from "@mantine/core";
import { FieldData } from "../../../hooks/useForm";

const UsersMultiSelect = ({
  placeHolder,
  setupKind,
  isMulti,
  formData,
  options,
  label,
  ...rest
}: {
  name: string;
  label?: string;
  placeHolder?: string;
  setupKind?: SetupKind;
  options?: {
    required?: boolean;
    isRequired?: Function;
  };
  isMulti?: boolean;
  readOnly?: boolean;
  onChange?: Function;
  formData?: Map<string, any>;
}) => {
  console.log({ fieldName: rest.name, formData });
  const [choices, setChoices] = useState<SelectChoice[]>([]);
  const [getUsers] = useLazyQuery(GET_ALL_USERS, {
    fetchPolicy: "network-only",
  });

  const initVal = (): SelectChoice | SelectChoice[] | undefined => {
    const value = formData?.get(rest.name);
    console.log({ value })
    if (!value) return isMulti ? [] : undefined;

    if (Array.isArray(value))
      return choices.filter((o) => value.includes(o.value));

    let res = choices.find((o) => parseInt(o.value) === parseInt(value));
    console.log({ res, choices })
    return res;
  };

  const initValue = initVal();
  const [show, setShow] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [selected, setSelected] = useState<
    SelectChoice | SelectChoice[] | undefined
  >();
  const [searchValue, setSearchValue] = useState("");
  const selectElRef = useRef<HTMLDivElement>(null);

  const removeOption = (option: SelectChoice) => {
    if (!Array.isArray(selected)) return [];
    return selected.filter((o) => o.value !== option.value);
  };

  useEffect(() => {
    const currValue = formData?.get(rest.name);
    let selectedIds: number[] = [];
    if (currValue) {
      if (Array.isArray(currValue)) {
        selectedIds = currValue.map((s) => parseInt(s.value || s));
      } else {
        selectedIds = [parseInt(currValue)];
      }
    }
    getUsers({
      variables: {},
    }).then((res) => {
      let users = res.data.getUsers;
      let resData = users.map((u: any) => {
        return {
          label: `${u.firstName} ${u.lastName}`,
          value: u.id,
        };
      });
      setChoices(() => resData);
    });
  }, []);

  useEffect(() => {
    if (selectElRef.current) {
      let el = selectElRef.current;
      let rect = el.getBoundingClientRect();
      el.style.setProperty("--pos-top", `${rect.top}`);
      el.style.setProperty("--pos-left", `${rect.left}`);
      el.style.setProperty("--pos-width", `${rect.width}`);
    }
  }, []);

  const getValue = () => {
    if (selected === null) return null;
    if (!Array.isArray(selected)) return selected?.value;
    return selected.map((i) => i.value);
  };
  useEffect(() => {
    if (!isChanged) {
      setIsChanged(true);
      return;
    }
    if (!rest.onChange) return;

    rest.onChange({
      name: rest.name,
      value: getValue(),
    });
  }, [selected]);

  useEffect(() => {
    console.log({ fieldName: rest.name, initValue });
    setSelected(initValue);
  }, [initValue]);



  // return (
  //   <div
  //     className={`dropdown-container relative bottom-1 rounded h-full top-0 ${rest.readOnly ? "readonly" : ""}`}
  //     ref={selectElRef}
  //   >
  //     <input
  //       type="text"
  //       name={rest.name}
  //       defaultValue={formData?.get(rest.name)}
  //       required={options?.required}
  //       className="multiselect-value-holder-input"
  //       style={{
  //         visibility: formData?.has(rest.name) ? "hidden" : undefined,
  //       }}
  //     />
  //     <div
  //       className="dropdown-input flex items-center justify-between select-none h-full gap-2"
  //       style={{ minWidth: 0 }}
  //       onClick={handleSelectClick}
  //     >
  //       <div className="dropdown-selected-value flex-1 pl-3 text-sm">
  //         {getDisplay()}
  //       </div>
  //       <div className="dropdown-tools">
  //         <div className="dropdown-tool">
  //           <Icon />
  //         </div>
  //       </div>
  //     </div>
  //     {show && !rest.readOnly && (
  //       <OutsideAlerter onOutClick={() => setShow(false)}>
  //         <div className="dropdown-menu absolute overflow-auto bg-white w-full border top-10 shadow-lg rounded">
  //           <div
  //             className="search-box"
  //             onClick={(ev: any) => ev.stopPropagation()}
  //           >
  //             <input
  //               onChange={onSearch}
  //               value={searchValue}
  //               ref={searchRef}
  //               className="w-full border-b outline-none px-3 py-1 text-sm"
  //               placeholder="Filter ..."
  //             />
  //           </div>
  //           <div className="dropdown-options-wrap flex flex-col">
  //             {choices.map((o, idx) => (
  //               <div
  //                 key={o.value}
  //                 className={`dropdown-item cursor-pointer px-3 py-1 ${isSelected(o) && "selected"}`}
  //                 onClick={() => onItemClick(o)}
  //               >
  //                 {o.label}
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       </OutsideAlerter>
  //     )}
  //   </div>
  // );

  function getSelectValue() {
    let v = formData?.get(rest.name);
    return `${v}`
  }

  const selectOnChange = (data: FieldData) => {
    rest.onChange && rest.onChange(data);
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    const splittedSearch = search.toLowerCase().trim().split(" ");
    return (options as ComboboxItem[]).filter((option) => {
      const words = option.label.toLowerCase().trim().split(" ");
      return splittedSearch.every((searchWord) =>
        words.some((word) => word.includes(searchWord)),
      );
    });
  };

  return <Select
    {...rest}
    placeholder={`Select ${label}`}
    // defaultValue={getSelectValue()}
    value={getSelectValue()}
    label={label}
    radius={"md"}
    required={options?.required || undefined}
    searchable
    data={
      choices?.map((c) => {
        return {
          ...c,
          value: `${c.value}`,
          label: c.label || "",
        };
      }) || []
    }
    onChange={(value) => {
      selectOnChange({
        name: rest.name,
        value: choices?.find(
          (c) => c.value?.toString() === value,
        )?.value,
      });
    }}
    filter={optionsFilter}
    readOnly={rest?.readOnly}
  />
};

export default UsersMultiSelect;
